/**
 *
 * @param input String to be tested
 * @returns `true` if input does not contain unicode characters (e.g. emoji)
 */
export const isValidCharacters = (input: string): boolean => {
  const test = /^[\p{L}\d _\-'&@.,?!]*$/u;
  return test.test(input);
};

export const hasUrlProtocol = (input: string) => {
  const regex = /^(https?:\/\/)/;
  return regex.test(input);
};
